import { Components } from '@mui/material';

export const MuiDialog: Components['MuiDialog'] = {
  defaultProps: {
    // Without disableEnforceFocus, having the modal open and then clicking
    // any of the Bottomsheet drawers from react-spring-bottom-sheet will cause
    // an infinite recursion loop: https://stackoverflow.com/questions/54133326/material-ui-uncaught-rangeerror-maximum-call-stack-size-exceeded/54133377#54133377
    // We should find another way to address this, as disableEnforceFocus is
    // important for keyboard accessibility. Perhaps we can remove this if/when
    // we migrate off react-spring-bottom-sheet: (https://trello.com/c/eUp6DMKx/)
    disableEnforceFocus: true,
  },
};
